export enum ErrorType {
  PageNotFound = 'PAGE_NOT_FOUND',
  PageTypeInvalid = 'PAGE_TYPE_INVALID',
  PageCancelled = 'PAGE_CANCELLED',
}

export enum AlertTypes {
  warning = 'warning',
  error = 'error',
  success = 'success',
  info = 'info',
}

export enum QueryParameters {
  ALERT_TYPE = 'alertType',
  ALERT_MESSAGE = 'alertMessage',
}

export enum QueryMessages {
  DONATION_ERROR = 'donationError',
  DONATION_ERROR_NOT_SUPPORTED = 'donationErrorNotSupported',
}
